export default "/img/merchantcapital.png"